import { get, post } from "../utils/request";

/**
 * 获取订单列表
 * @param {\} vm
 * @param {*} cb
 */
export const getOrderList = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    name: vm.keyword,
    pageNo: vm.current,
    pageSize: vm.display
  };
  if (vm.afterCancelOrderType) {
    params.name = "";
  }
  vm.orderData = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/order/orderByUserIdList", params)
    .then(res => {
      vm.isloading = false;
      //console.log(res);
      if (res.code === 200) {
        let list = res.data.list || [];
        //order_goods_type` int(1) DEFAULT NULL COMMENT '0 拍卖订单 1商品订单',
        // order_goods_type === 0  拍品信息取 tauctionNper  ===1 取orderGoodsInfoList
        vm.orderData = list.map(item => {
          let infoList = [];
          if (item.orderGoodsType === 1) {
            //普通商品订单
            infoList = item.orderGoodsInfoList.map(val => {
              if (val.goods) {
                val.imgsUrl = val.goods.imgsUrl
                  ? vm.comImgUrl + val.goods.imgsUrl.split("|")[0]
                  : "";
              } else {
                val.imgsUrl = "";
              }
              return val;
            });
          } else {
            //拍品订单
            let auctionlist = [];
            auctionlist.push(item.tauctionNper ? item.tauctionNper : {});
            infoList = auctionlist.map(val => {
              let Item = {};
              Item.auctionId = val.auctionId;
              Item.id = val.id;
              Item.name = val.name;
              Item.number = 1;
              Item.imgsUrl = val.imgsUrl
                ? vm.comImgUrl + val.imgsUrl.split("|")[0]
                : "";
              Item.specs = "";
              //auction_type` int(1) DEFAULT NULL COMMENT '拍卖类型 0 秒杀价拍卖 1 普通拍卖',
              Item.price =
                val.auctionType === 0 ? val.seckillPrice : val.transactionPrice;
              Item.totalPrice = Item.price;
              return Item;
            });
          }
          item.orderGoodsInfoList = infoList;
          return item;
        });
        vm.total = res.data.total;
      }
      vm.nodata = vm.orderData.length == 0 ? true : false;
      vm.$tips_msg(vm, res);
      cb && cb(res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.orderData.length == 0 ? true : false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 提交订单
 * @param {*} vm
 * @param {*} cb
 */
export const addOrder = (vm, cb) => {
  post("/api/order/addorder", vm.paydata)
    .then(res => {
      vm.isLoading = false;
      if (res.code === 200) {
        if (vm.payType == 1 || vm.payType == 2) {
          vm.$router.push({
            name: "orderSuccess",
            params: {
              id: res.data.id
            }
          });
        } else {
          vm.$router.push({
            name: "orderPay",
            params: {
              id: res.data.id
            }
          });
        }
        cb && cb();
      } else {
        vm.$notify({
          title: "提示",
          message: "失败：" + res.message,
          type: "error"
        });
      }
    })
    .catch(error => {
      vm.isLoading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 更新拍品订单
 * @param {*} vm
 * @param {*} cb
 */
export const updataAuctionOrder = (vm, cb) => {
  post("/api/order/updateorder", vm.paydata)
    .then(res => {
      if (res.code == 200) {
        vm.isLoading = false;
        if (res.code === 200) {
          if (vm.payType == 1 || vm.payType == 2) {
            vm.$router.push({
              name: "orderSuccess",
              params: {
                id: res.data.id
              }
            });
          } else {
            if (vm.waitPaidPrice === 0) {
              vm.$notify({
                title: "提示",
                message: "支付成功，已从定金中扣除",
                type: "success"
              });
              setTimeout(() => {
                vm.$router.push({
                  name: "orderList"
                });
              }, 500);
            } else {
              vm.$router.push({
                name: "orderPay",
                params: {
                  id: res.data.id
                }
              });
            }
          }
        }
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isLoading = false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 根据订单号获取订单详情
 * @param {*} vm
 * @param {*} cb
 */
export const orderDetail = (vm, cb) => {
  let params = {
    id: vm.orderId
  };
  post("/api/order/searchOrderInfoById", params)
    .then(res => {
      //console.log(res);
      /**
       * 如果是拍品订单
       * bid对象 bidType出价类型  0 秒杀 1 普通拍卖
       * orderGoodsType  0拍品 1商品
       * order_goods_type` int(1) DEFAULT NULL COMMENT '0 拍卖订单 1商品订单',
       * order_status'订单状态 0 逾期 1 已支付 2未支付',
       * receiveWay '收货方式 0 自提  1 快递',
       * pay_method付款方式   0在线支付 1 货到付款 2微信转账
       * pay_type支付类型 0 支付宝 1 微信
       */
      if (res.code === 200) {
        vm.auctionInfo = res.data || {};
        vm.auctionInfo.logisticsAddress = vm.auctionInfo.logisticsAddress
          ? vm.auctionInfo.logisticsAddress
          : {};

        if (res.data.receiveWay === 0) {
          vm.hasWl = false;
        } else {
          vm.hasWl =
            JSON.stringify(vm.auctionInfo.logisticsAddress) == "{}"
              ? false
              : true;
        }
        let shoplist = res.data.orderGoodsInfoList || [],
          str = "",
          address = res.data.logisticsAddress || {};
        if (res.data.orderGoodsType == 1) {
          //商品
          vm.shopList = shoplist;

          shoplist.forEach((element, index) => {
            str += element.name;
            if (index < shoplist.length - 1) {
              str += ",";
            }
          });
          vm.shopNameText = str;
          vm.isShowDj = false;
        } else {
          // 拍品
          vm.shopNameText = res.data.auction.name;
          if (
            res.data.tauctionNper &&
            res.data.tauctionNper.auctionType === 0
          ) {
            //秒杀显示定金
            vm.isShowDj = true;
          } else {
            vm.isShowDj = false;
          }
        }
        vm.orderPrice = res.data.orderPrice;
        vm.orderGoodsType = res.data.orderGoodsType;

        vm.addressText =
          address.consignee +
          " " +
          address.contactPhone +
          " " +
          address.shippingAddress;
      }
      if (cb !== undefined) {
        cb(res);
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 取消订单
 * @param {*} vm
 * @param {*} id
 * @param {*} cb
 */
export const cancelOrder = (vm, id, cb) => {
  post("/api/order/deleteGoodsOrder", { id: id })
    .then(res => {
      if (res.code === 200) {
        vm.$notify({
          title: "提示",
          message: "取消订单成功",
          type: "success"
        });
      } else {
        vm.$notify({
          title: "提示",
          message: "失败: " + res.message,
          type: "error"
        });
      }
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
      //console.log(error);
    });
};

/**
 * 再次购买
 * @param {*} vm
 * @param {*} cb
 */
export const onceAgain = (vm, id, cb) => {
  post("/api/order/onceAgain", { id: id })
    .then(res => {
      //console.log(res);
      if (res.code === 200) {
        /* vm.$message({
          message: "再次购买成功",
          type: "success"
        }); */
        setTimeout(() => {
          vm.$router.push({
            name: "cartList"
          });
        }, 300);
      } else {
        vm.$notify({
          title: "提示",
          message: "失败: " + res.message,
          type: "error"
        });
      }
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
      //console.log(error);
    });
};

/**
 * 支付-微信
 * @param {*} vm
 * @param {*} cb
 */
export const payWechart = (vm, cb) => {
  /**
   * String orderId,
   * String isDeposit 是否为押金  => 0 订单支付  1 押金支付,
   * String userId,
   * String auctionId 拍品id, 支付押金的时候传，其他传值为空
   */
  let params = {
    orderId: vm.orderId ? vm.orderId : "",
    isDeposit: vm.isDeposit,
    userId: vm.userInfo.userId,
    auctionId: vm.isDeposit === 1 ? vm.detailObj.auctionId : ""
  };

  get("/pay", params)
    .then(res => {
      cb && cb(res);
    })
    .catch(error => {
      //console.log(error);
    });
};

/**
 * 支付-支付宝
 * @param {*} vm
 * @param {*} cb
 */
export const payAlipay = (vm, cb) => {
  /**
   * String orderId,
   * String isDeposit 是否为押金 0 订单支付  1 押金支付,
   * String userId,
   * String auctionId 拍品id, 支付押金的时候传，其他传值为空
   * orderGoodsType  0拍品 1商品
   */
  let params = {
    orderId: vm.orderId ? vm.orderId : "",
    isDeposit: vm.isDeposit,
    userId: vm.userInfo.userId,
    auctionId: vm.isDeposit === 1 ? vm.detailObj.auctionId : "123",
    retrunUrl: vm.returnUrl,
    price: vm.payPrice
  };
  post("/api/alipay/pay", params)
    .then(res => {
      vm.isPayLoading = false;
      //console.log(res);
      if (res.code == 200) {
        if (res.data == "505") {
          vm.$notify({
            title: "提示",
            message: "支付失败，该订单已关闭",
            type: "info"
          });
        } else {
          vm.payAlipayForm = res.data;
          cb && cb(res);
        }
      } else {
        vm.$notify({
          title: "提示",
          message: "支付失败",
          type: "error"
        });
      }
      //console.log(res);
    })
    .catch(error => {
      vm.isPayLoading = false;
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 检测订单是否支付成功
 * @param {*} vm
 * @param {*} cb
 */
export const checkOrderPay = (vm, cb) => {
  post("/api/parameter/payOrderReturnParamter", { orderId: vm.orderId })
    .then(res => {
      let bool = true;
      if (res.code === 200) {
        if (res.data.returnParameter) {
          let reg = /return_code=SUCCESS/gi;
          if (reg.test(res.data.returnParameter)) {
            vm.$notify({
              title: "提示",
              message: "支付成功",
              type: "success"
            });
            bool = true;
          } else {
            vm.$notify({
              title: "提示",
              message: "支付失败",
              type: "error"
            });
            bool = false;
          }
        } else {
          vm.$notify({
            title: "提示",
            message: "尚未支付",
            type: "warning"
          });
          bool = false;
        }
      } else {
        vm.$notify({
          title: "提示",
          message: "失败" + res.message,
          type: "error"
        });
        bool = false;
      }
      cb && cb(bool);
    })
    .catch(error => {
      cb && cb(false);
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 检测押金是否支付成功
 * @param {*} vm
 * @param {*} cb
 */
export const checkDepositPay = (vm, cb) => {
  post("/api/parameter/depositReturnParamter", { tradeNo: vm.orderId })
    .then(res => {
      if (res.code === 200) {
        if (res.data.returnParameter) {
          let reg = /return_code=SUCCESS/gi;
          if (reg.test(res.data.returnParameter)) {
            vm.$notify({
              title: "提示",
              message: "支付成功",
              type: "success"
            });
            vm.isHasSpike = true;
          } else {
            vm.$notify({
              title: "提示",
              message: "支付失败",
              type: "error"
            });
            vm.isHasSpike = false;
          }
        } else {
          vm.$notify({
            title: "提示",
            message: "尚未支付",
            type: "warning"
          });
          vm.isHasSpike = false;
        }
      } else {
        vm.$notify({
          title: "提示",
          message: "支付失败",
          type: "error"
        });
        vm.isHasSpike = false;
      }
      cb && cb(res);
    })
    .catch(error => {
      //console.log(error);
      vm.isHasSpike = false;
    });
};

/**
 * 订单逾期时间
 * @param {*} vm
 * @param {*} cb
 */
export const overTime = (vm, cb) => {
  post("/api/orderReminderTime/selectById")
    .then(res => {
      if (res.code == 200) {
        vm.overtime = res.data.overTime;
      }
    })
    .catch(error => {
      console.log(error);
    });
};

/**
 * 获取微信账号
 * @param {*} vm
 * @param {*} cb
 */
export const getWeChartAccount = (vm, cb) => {
  post("/api/order/weixin")
    .then(res => {
      if (res.code == 200) {
        vm.WeChartAccount = res.data.weixin;
      }
    })
    .catch(error => {
      console.log(error);
    });
};
